import { useCallback } from "react";
import { endAt, limitToFirst, onValue, orderByChild, query, ref as dbRef, ref, startAt } from "firebase/database";
import { database } from "../firebase";

export const useGetDbData = () => {
    const sendRequest = useCallback(
        <T>(
            requestConfig: {
                table: string;
                orderBy?: string;
                where?: string | number | boolean;
                limit?: number;
                isExact?: boolean;
            },
            applyData: (dbData: T) => void
        ) => {
            const gamesDbRef =
                requestConfig.orderBy && !requestConfig.where && !requestConfig.limit
                    ? query(ref(database, requestConfig.table), orderByChild(requestConfig.orderBy))
                    : requestConfig.orderBy && requestConfig.where && !requestConfig.limit
                    ? query(
                          ref(database, requestConfig.table),
                          orderByChild(requestConfig.orderBy),
                          startAt(requestConfig.where),
                          endAt(requestConfig.where + `${requestConfig.isExact ? "\uf8ff" : ""}`)
                      )
                    : requestConfig.orderBy && requestConfig.where && requestConfig.limit
                    ? query(
                          ref(database, requestConfig.table),
                          orderByChild(requestConfig.orderBy),
                          startAt(requestConfig.where),
                          endAt(requestConfig.where + `${requestConfig.isExact ? "\uf8ff" : ""}`),
                          limitToFirst(requestConfig.limit)
                      )
                    : dbRef(database, requestConfig.table);

            onValue(gamesDbRef, (snapshot) => {
                applyData(snapshot.val());
            });
        },
        []
    );

    return { sendRequest };
};
